import { NotificationService } from 'src/app/shared/services/notification-service/notification.service';
import { ReportingService } from 'src/app/shared/services/reporting-service/reporting.service';
import { AdditionalPolicyPlanFigureDto } from 'src/app/services/property-matrixV2/models';
import { PlanningReportService } from 'src/app/services/property-matrixV2/services';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-additional-policy-plan-figure',
  templateUrl: './additional-policy-plan-figure.component.html',
  styleUrls: ['./additional-policy-plan-figure.component.scss', '../../../../../../../../css/2-modules/_admin-portal.scss']
})
export class AdditionalPolicyPlanFigureComponent implements OnInit {

  @Input() planningReportId: string;
  @Output() additionalPolicyChange = new EventEmitter<AdditionalPolicyPlanFigureDto[]>();

  additionalPolicyPlanFigureData: AdditionalPolicyPlanFigureDto[] = [];

  file: any;
  fileId: string = null;
  fileUrls: string[] = [];
  hideButtons: boolean = false;

  maxAdditionalPolicies: number = 9;

  constructor(
    private reportingService: ReportingService,
    private notificationService: NotificationService,
    private planningReportService: PlanningReportService
  ) { }

  ngOnInit(): void {
    this.loadAdditionalPolicyDetails();
  }

  async setFile(event: { target: { files: any[]; }; }, index: number): Promise<void> {
    try {
      this.fileId = await this.reportingService.uploadFile(event.target.files[0]);
      this.additionalPolicyPlanFigureData[index].imageUrl = this.fileId;
      this.emitChanges();

      this.file = event.target.files[0];

      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.fileUrls[index] = event.target.result;
        this.hideButtons = true;
      }

      reader.readAsDataURL(this.file);
    } catch (error) {
      this.notificationService.showErrorMessage('Error', 'Could not upload file.');
    }
  }

  async loadFile(index: number): Promise<void> {
    const additionalPolicy = this.additionalPolicyPlanFigureData[index];
    if (additionalPolicy.imageUrl) {
      try {
        const fileUrl = await this.reportingService.getFileUrl(additionalPolicy.imageUrl);
        this.fileUrls[index] = fileUrl;
        this.hideButtons = !!fileUrl;
        this.emitChanges();
      } catch (error) {
        this.notificationService.showErrorMessage('Error', 'Could not load file.');
      }
    }
  }

  async loadAllFiles(): Promise<void> {
    for (let i = 0; i < this.additionalPolicyPlanFigureData.length; i++) {
      await this.loadFile(i);
    }
  }

  addItemToArray(array: any[], item: any): void {
    array.push(item);
    this.emitChanges();
  }

  removeItemFromArray(array: any[], index: number): void {
    if (index >= 0 && index < array.length) {
      array.splice(index, 1);
      this.emitChanges();
    }
  }

  createAdditionalPolicy(): void {
    const newAdditionalPolicy: AdditionalPolicyPlanFigureDto = {
      id: uuidv4(),
      description: '',
      imageName: '',
      imageUrl: '',
      name: ''
    };
    this.addItemToArray(this.additionalPolicyPlanFigureData, newAdditionalPolicy);
  }

  addAdditionalPolicy(): void {
    if (this.additionalPolicyPlanFigureData.length < this.maxAdditionalPolicies) {
      this.createAdditionalPolicy();
    } else {
      this.notificationService.showWarningMessage('Additional Policy Limit Reached', 'You cannot add more than ' + this.maxAdditionalPolicies + ' additional policies.');
    }
  }

  async removeAdditionalPolicy(index: number): Promise<void> {
    const confirmed = await this.notificationService.showConfirmMessage(
      'Confirm Deletion',
      'Are you sure you want to remove this item? This action cannot be undone.',
      'Remove',
      'Cancel'
    );

    if (!confirmed) {
      return;
    }

    this.removeItemFromArray(this.additionalPolicyPlanFigureData, index);
    this.fileUrls.splice(index, 1);
  }

  loadAdditionalPolicyDetails(): void {
    this.planningReportService.apiV1PlanningReportGetAdditionalPoliciesGet({
      planningReportId: this.planningReportId
    }).subscribe({
      next: async (response) => {
        this.additionalPolicyPlanFigureData = response;
        if (this.additionalPolicyPlanFigureData === null || this.additionalPolicyPlanFigureData.length === 0) {
          this.createAdditionalPolicy();
        } else {
          await this.loadAllFiles();
        }
        this.emitChanges();
      },
      error: (_error: any) => {
        this.notificationService.showErrorMessage('Error', 'Could not load additional policies.');
      }
    });
  }

  emitChanges(): void {
    this.additionalPolicyChange.emit(this.additionalPolicyPlanFigureData);
  }

  replace(index: number): void {
    this.hideButtons = false;
    this.fileUrls[index] = "";
    this.fileId = "";
    this.additionalPolicyPlanFigureData[index].imageUrl = null;
  }
}